import React, { useState, useEffect, useRef } from 'react';
import { Calendar as CalendarIcon, Clock, Users, MapPin } from 'lucide-react';
import axios from '../../api/axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { MdRestaurantMenu } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import image from '../../assets/images/rooftop.png';
import logo from '../../assets/images/SHTATO LOGO.jpg';
import image1 from '../../assets/images/image2.png';
import image2 from '../../assets/images/shtattomarrakech1.jpeg';
import image3 from '../../assets/images/shtattomarrakech2.jpeg';
import image4 from '../../assets/images/shtattomarrakech3.jpeg';
import image5 from '../../assets/images/shtattomarrakech4.jpeg';
import menu1 from '../../assets/images/menu1.jpg';
import menu2 from '../../assets/images/menu2.jpg';
import { GoChevronDown } from "react-icons/go";

const RESERVATION_URL = "/api/reservation/create";
const IS_AVAILABLE = "/api/reservation/available";

const images = [image, image1, image2, image3, image4, image5];
const menuImages = [menu1, menu2];

const ReservationForm = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        people: '',
        date: new Date(),
        time: '',
        zone: '',
        name: '',
        email: '',
        phone: '',
        comments: '',
    });
    const [availableTimes, setAvailableTimes] = useState([]);
    const [error, setError] = useState('');
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [randomImage, setRandomImage] = useState(images[0]);
    const [suggestionMessage, setSuggestionMessage] = useState('');
    const calendarRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isImageOpen, setIsImageOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const closeImageModal = () => {
        setIsImageOpen(false);
        setSelectedImage(null);
    };

    const openMenu = (image) => {
        setSelectedImage(image);
        setIsMenuOpen(true);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        setSelectedImage(null);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setIsCalendarOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * images.length);
        setRandomImage(images[randomIndex]);
    }, []);

    const fetchAvailableTimes = async () => {
        if (!formData.date || !formData.zone) {
            setError('Please select a date and zone first.');
            return;
        }

        try {
            const response = await axios.get(IS_AVAILABLE, {
                params: { date: formData.date.toLocaleDateString('fr-CA'), zone: formData.zone }
            });

            let availableTimes = response.data;
            const now = new Date();
            const selectedDate = new Date(formData.date);

            if (selectedDate.toDateString() === now.toDateString()) {
                const oneHourLater = now.getHours() + now.getMinutes() / 60 + 1;
                availableTimes = availableTimes.filter(({ time }) => time >= oneHourLater);
            }

            setAvailableTimes(availableTimes);
            setError('');
            setSuggestionMessage('');
        } catch (err) {
            console.error(err);
            setError('Error fetching available times.');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDateChange = (selectedDate) => {
        const utcDate = new Date(Date.UTC(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate()
        ));

        setFormData({ ...formData, date: utcDate });
        setIsCalendarOpen(false);
    };

    const nextStep = () => {
        const requiredFields = [
            { name: 'people', label: 'People' },
            { name: 'date', label: 'Date' },
            { name: 'time', label: 'Time' },
            { name: 'zone', label: 'Zone' },
        ];

        const missingFields = requiredFields.filter(field => !formData[field.name]);

        if (missingFields.length > 0) {
            const fieldNames = missingFields.map(field => field.label).join(', ');
            setError(`Please fill in the following required fields before proceeding: ${fieldNames}.`);
            return;
        }

        setError('');
        setStep(step + 1);
    };

    const previousStep = () => {
        setStep(step - 1);
    };

    const formatTime = (time) => {
        const hours = Math.floor(time);
        const minutes = (time % 1) * 60;
        const timeString = `${hours.toString().padStart(2, '0')}:${minutes === 0 ? '00' : '30'}`;
        return new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const selectTime = (time) => {
        if (availableTimes.find(t => t.time === time && t.isAvailable)) {
            setFormData({ ...formData, time: time });
            setError('')
            setSuggestionMessage('');
        } else if (formData.zone === 'rooftop') {
            setSuggestionMessage('The selected time is not available in the rooftop. You can book in the salon instead.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formattedData = {
                ...formData,
                date: formData.date.toISOString().split('T')[0]
            };
            const response = await axios.post(RESERVATION_URL, formattedData);
            console.log("Reservation successful:", response.data);
            navigate('/confirmation', { state: formattedData });
        } catch (error) {
            if (error.response) {
                console.error("API Error:", error.response.data);
                setError(error.response.data.error);
            } else {
                console.error("Error:", error.message);
                setError('An unexpected error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full max-w-5xl mx-auto space-y-8">
            <div className="flex justify-center mt-4">
                <img src={logo} alt='Shtatto' className='w-1/5 sm:w-1/3 md:w-1/3' />
            </div>

            <div className="w-full h-[50vh] md:h-[40vh] lg:h-[30vh] overflow-hidden">
                <img src={randomImage} alt='shtatto' className='w-full h-full object-cover' />
            </div>

            <h1 className="text-5xl text-[#231f20] text-center font-semibold text-center" style={{ fontFamily: "Goudy Bookletter 1911, serif" }}>BOOK YOUR <br /> TABLE NOW!</h1>

            <div className="space-y-2 mb-8 ml-14">
                <div className="flex items-center space-x-2">
                    <MapPin size={20} />
                    <p style={{ fontFamily: "Goudy Bookletter 1911, serif" }}>81 Derb Nkhal, Rahba Lakdima, <br /> Marrakech 40000</p>
                </div>
                <div className="flex items-center space-x-2">
                    <Clock size={20} />
                    <p style={{ fontFamily: "Goudy Bookletter 1911, serif" }}>09:30 AM - 11:00 PM</p>
                </div>
                <div
                    onClick={() => openMenu()} // Open menu when clicked
                    className="flex items-center space-x-2 cursor-pointer"
                >
                    <MdRestaurantMenu size={20} />
                    <button
                        className="text-gray-600 hover:text-black"
                        style={{ fontFamily: "Goudy Bookletter 1911, serif" }}
                    >
                        Show Menu
                    </button>
                </div>
            </div>

            {isMenuOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-4 w-full max-w-4xl h-[90vh] relative">
                        <button
                            onClick={closeMenu}
                            className="absolute top-2 right-2 text-gray-500 hover:text-black text-2xl font-bold"
                        >
                            &times;
                        </button>

                        <div className="flex overflow-x-auto space-x-4 p-8">
                            {menuImages.map((image, index) => (
                                <img
                                    key={index}
                                    src={image}
                                    alt={`Menu Image ${index + 1}`}
                                    className="w-full max-w-[350px] h-auto rounded-lg cursor-pointer"
                                    onClick={() => openMenu(image)}
                                />
                            ))}
                        </div>

                        {selectedImage && (
                            <div
                                className="absolute inset-0 bg-black bg-opacity-75 flex items-center justify-center cursor-pointer"
                                onClick={closeImageModal}
                            >
                                <img
                                    src={selectedImage}
                                    alt="Selected Menu"
                                    className="max-w-full max-h-full object-contain"
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
                {step === 1 && (
                    <>
                        <div className="flex flex-col md:flex-row gap-4 px-10">
                            <div className="relative flex-1">
                                <div className="relative">
                                    {!isCalendarOpen ? (
                                        <button
                                            type="button"
                                            onClick={() => setIsCalendarOpen(true)}
                                            className="w-full px-2 py-2 border rounded-lg flex items-center justify-between"
                                        >
                                            <div className="flex items-center">
                                                <CalendarIcon className="w-5 h-5 mr-2" />
                                                <span>{formData.date ? formData.date.toLocaleDateString('fr-FR') : "Date"}</span>
                                            </div>
                                            <span><GoChevronDown color='black' /></span>
                                        </button>
                                    ) : (
                                        <div ref={calendarRef} className="absolute z-10 bg-white border rounded-lg shadow-lg">
                                            <Calendar
                                                onChange={handleDateChange}
                                                value={formData.date}
                                                minDate={new Date()}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="relative flex-1">
                                <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black" size={20} />
                                <select
                                    name="zone"
                                    value={formData.zone}
                                    onChange={handleChange}
                                    className="w-full min-w-full px-10 py-2 border rounded-lg bg-white appearance-none"
                                >
                                    <option value="" disabled>Zone</option>
                                    <option value="salon">Salon</option>
                                    <option value="rooftop">Rooftop</option>
                                </select>
                            </div>

                            <div className="relative flex-1">
                                <Users className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black" size={20} />
                                <input
                                    name="people"
                                    type="number"
                                    value={formData.people}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value);
                                        if (value >= 1 && value <= 20) {
                                            handleChange(e);
                                        }
                                    }}
                                    className="w-full px-10 py-2 border rounded-lg"
                                    placeholder="People"
                                    min={1}
                                    max={100}
                                />
                            </div>

                            <div className="relative flex-1">
                                <Clock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black" size={20} />
                                <input
                                    name="time"
                                    readOnly
                                    value={formatTime(formData.time)}
                                    onChange={handleChange}
                                    onClick={fetchAvailableTimes}
                                    className="w-full px-10 py-2 border rounded-lg cursor-pointer"
                                />
                            </div>

                            <div className="relative flex-1">
                                <button
                                    type='button'
                                    onClick={fetchAvailableTimes}
                                    className="w-full md:w-auto px-4 py-3 font-semibold bg-black text-white rounded-lg hover:bg-gray-800"
                                >
                                    Find Your Slots
                                </button>
                            </div>
                        </div>

                        <div className="flex flex-col px-7">
                            <p className='text-black font-semibold' style={{ fontFamily: "Goudy Bookletter 1911, serif" }}>Available Time slots</p>
                        </div>

                        {
                            availableTimes.length > 0 && (
                                <div className="mt-8 px-8">
                                    {error && <div className="text-red-600 mb-4">{error}</div>}
                                    {suggestionMessage && <div className="text-red-600 mb-4">{suggestionMessage}</div>}
                                    <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
                                        {availableTimes.map(({ time, isAvailable }) => (
                                            <button
                                                type='button'
                                                key={time}
                                                className={`px-2 py-3 rounded-xl text-sm
                                                    ${isAvailable
                                                        ? formData.time === time
                                                            ? 'bg-green-600 text-white'
                                                            : 'bg-[#E0E0E0] hover:bg-gray-300'
                                                        : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                    }`}
                                                onClick={() => selectTime(time)}
                                            >
                                                {formatTime(time)}
                                            </button>
                                        ))}
                                    </div>
                                    <div className="border-dashed border-t border-gray-300 mb-2 mt-4"></div>
                                    <p className='text-gray-500 font-semibold opacity-[0.8] mb-2' style={{ fontFamily: "Goudy Bookletter 1911, serif" }}>
                                        <strong>Reservation Terms & Conditions</strong>
                                        <br />
                                        Please note that reservations are available for dining only. We are unable to accommodate bookings for drinks alone. To ensure the best experience, we kindly ask guests to arrive on time.
                                        <br /><br />
                                        During peak hours (especially between 7:00 and 8:30 PM), tables are in high demand; early reservations are recommended. Reserved tables will be held for 15 minutes past the booking time before being released. For any changes or cancellations, please notify us as soon as possible.
                                        <br /><br />
                                        Thank you for your understanding and cooperation!
                                    </p>
                                </div>
                            )
                        }
                    </>
                )}
                {step === 2 && (
                    <div className="space-y-6 px-8">
                        <div>
                            <label htmlFor="name" className="block mb-1 text-sm font-medium text-gray-700">
                                Full Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Full Name..."
                                className="w-full px-4 py-2 text-black border border-gray-300 rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="block mb-1 text-sm font-medium text-gray-700">
                                Email <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email..."
                                className="w-full px-4 py-2 text-black border border-gray-300 rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="phone" className="block mb-1 text-sm font-medium text-gray-700">
                                Phone
                            </label>
                            <input
                                type="tel"
                                name="phone"
                                id="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Phone..."
                                className="w-full px-4 py-2 text-black border border-gray-300 rounded-lg"
                            />
                        </div>
                        <div>
                            <label htmlFor="comments" className="block mb-1 text-sm font-medium text-gray-700">
                                Comments
                            </label>
                            <textarea
                                name="comments"
                                id="comments"
                                value={formData.comments}
                                onChange={handleChange}
                                placeholder="Comments..."
                                rows={4}
                                maxLength={1500}
                                className="w-full px-4 py-2 text-black border border-gray-300 rounded-lg"
                            />
                            <div className="text-gray-400 text-sm text-right mt-1">
                                {formData.comments.length}/1500 Characters
                            </div>
                        </div>
                    </div>
                )}

                <div className="relative flex gap-2 justify-center pb-12">
                    {step > 1 && (
                        <button
                            type="button"
                            onClick={previousStep}
                            className="px-6 py-3 border font-semibold border-black text-black rounded-lg"
                        >
                            Back
                        </button>
                    )}

                    {step < 2 ? (
                        <button
                            type="button"
                            onClick={nextStep}
                            className="absolute top-0 right-0 px-6 py-2 bg-black text-white rounded-lg mr-8"
                        >
                            Next
                        </button>
                    ) : (
                        <button
                            type="submit"
                            className="px-6 py-3 font-semibold bg-black text-white rounded-lg flex items-center justify-center"
                            disabled={loading}
                        >
                            {loading ? (
                                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                                    <circle
                                        className="opacity-25"
                                        cx="12" cy="12" r="10"
                                        stroke="currentColor" strokeWidth="4"
                                        fill="none"
                                    />
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                                    />
                                </svg>
                            ) : (
                                "Complete your reservation"
                            )}
                        </button>
                    )}
                </div>
            </form>
        </div >
    );
};

export default ReservationForm;
